export default __webpack_public_path__ + "static/media/pending.a3fe3795.svg";